import React, { useContext } from 'react';
import { Col, Row as BSRow } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import NonRegisteredReportForm from '../comps/NonRegisteredReportForm';
import ReportChart from '../comps/ReportChart';
import TotalChart from '../comps/TotalChart';
import TotalReportForm from '../comps/TotalReportForm';
import {
	getBuysReportSum,
} from 'network/apis/ReportingApi';
import { DashboardContext } from 'context/DashboardContext';
import useScreen from 'hooks/useScreen';
import { useAdminSelector } from 'admin-app/redux/admin.store';

const Holder = styled.div`
	margin: 0 0.7rem;
`;

const Row = styled(BSRow)`
	background-color: white;
	border-bottom-left-radius: 26px;
	border-bottom-right-radius: 26px;
	border-top-right-radius: ${(props) => props.toprightradius ? props.toprightradius : '0'};

	&.bottom {
		border-top-left-radius: 26px;
		border-top-right-radius: 26px;
	}
`;

const ElevatedCol = styled(Col)`
	z-index: 2;
`;

const BuyTab = () => {
	const { currentTab } = useContext(DashboardContext);
	const filterState = useAdminSelector((store) => store.dashboardFilter);

	const { lessThan1200 } = useScreen();

	const { data: buys, isLoading } = useQuery(
		['get-buys-report', filterState.buysReportFilter],
		() => getBuysReportSum(filterState.buysReportFilter),
		{
			refetchOnWindowFocus: false,
			enabled: currentTab === 'buy'
		}
	);

	return (
		<Holder>
			<Row className='pt-3 pb-5'>
				<Col
					md={12}
					lg={12}
					xl={5}
					className={`d-flex justify-content-end ${!lessThan1200 ? 'ps-5' : ''}`}
				>
					<TotalChart
						data={buys?.list?.data?.items}
						tabName='buy'
						isLoading={isLoading}
					/>
				</Col>
				<ElevatedCol
					md={12}
					lg={12}
					xl={7}
				>
					<Row>
						<TotalReportForm
							reportType='buy'
							data={buys}
							isLoading={isLoading}
						/>
					</Row>
				</ElevatedCol>
			</Row>			
			{/* <Row className='mt-3 mb-5 pb-4 bottom'>				
				<Col md={7}>
					<Row toprightradius='26px'>
						<NonRegisteredReportForm title='گزارش عدم ثبت خرید استانی' reportType={'buy'} />
					</Row>
				</Col>
				<Col
					md={5}
					className={`d-flex justify-content-end ${!lessThan1200 ? 'pe-5' : ''}`}
				>
					<ReportChart reportType='buy' />
				</Col>
			</Row> */}
		</Holder>
	);
};

export default BuyTab;
